/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import useProduct from 'hooks/useProduct';
import Img from 'img';
import Icon from 'icon';
import { Link } from 'gatsby';

import s from './suggested-product.module.scss';

export default function SuggestedProduct({ config, ...props }) {
  const product = useProduct(props, config || {});
  const { id, title, image, slug, priceString, from, soldOut } = props;
  return (
    <div
      className={`${s.suggestedProduct} ${
        props.big ? s.big : ''
      } ${props.className || ''}`}
      key={id}
    >
      {!product.hasOptions && !soldOut && (
        <button type="button" onClick={product.submitMethod}>
          <span className={product.spin ? s.spinner : ''}>
            {!product.spin ? (
              <>&#43;</>
            ) : (
              <Icon icon="spinner" className="animate-spin" />
            )}
          </span>
        </button>
      )}
      <div className={s.image}>
        <Img className={s.img} src={image} small />
      </div>
      <Link
        className={s.suggestedTitle}
        to={`/product/${slug}`}
        {...(from ? { state: from } : {})}
      >
        {title}
      </Link>
      <p className={s.suggestedPrice}>{priceString}</p>
    </div>
  );
}
